import React from "react";

import '../css/Production.css';
import { getOSSImage } from "./Utils";

const titleImage = getOSSImage('zi_title_chanpinyoushi.png');
const contentImage = getOSSImage('chanpinyoushi.png');

export default function Production() {
    return (
        <div id="production" className="production-container">
            <img className="production-tile" alt="pro-title" src={titleImage}/>
            <img className="production-value" alt="pro-value" src={contentImage}/>
        </div>
    );
}